import { render, staticRenderFns } from "./MarketRatesList.vue?vue&type=template&id=3654b5c9&scoped=true&"
import script from "./MarketRatesList.vue?vue&type=script&lang=js&"
export * from "./MarketRatesList.vue?vue&type=script&lang=js&"
import style0 from "./MarketRatesList.vue?vue&type=style&index=0&id=3654b5c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3654b5c9",
  null
  
)

export default component.exports